import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/tipos-folio-vehicular/';

/**
 * GET Tipos Folio Vehiculares
 * @returns {Promise<Array<object>>}
 */
export const getTiposFoliosVehiculares = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET TipoFolioVehicular
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoFolioVehicular = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST TipoFolioVehicular
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoFolioVehicular = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH TipoFolioVehicular
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoFolioVehicular = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE TipoFolioVehicular
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoFolioVehicular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
